import React, { useCallback, useState } from 'react';
import { components } from 'react-select';
import { ix } from '../../../../../../utils/ix';
import { Button } from '../../../../../atoms';
import { SELECT_DROPDOWN_SELECT_ALL_VALUE } from '../../constants';
import { useStyles } from './AsyncMenuList.styles';
export function AsyncMenuList(props) {
    const { children, getValue, options } = props;
    const { id, showSelectAll } = props.selectProps.rootProps;
    const { onCancel, onSave } = props.selectProps.customProps;
    const classes = useStyles();
    const recalculateMenuValueWithSelectAll = useCallback((newTemporaryMenuValue) => {
        const selectedValues = newTemporaryMenuValue.filter((optionWithState) => optionWithState.isSelected && optionWithState.value !== SELECT_DROPDOWN_SELECT_ALL_VALUE);
        const isIndeterminate = selectedValues.length > 0 && selectedValues.length !== options.length - 1;
        const isSelected = selectedValues.length === options.length - 1 || isIndeterminate;
        return newTemporaryMenuValue.map((optionWithState) => optionWithState.value === SELECT_DROPDOWN_SELECT_ALL_VALUE
            ? Object.assign(Object.assign({}, optionWithState), { isSelected, isIndeterminate }) : optionWithState);
    }, [options]);
    const [temporaryMenuValue, setTemporaryMenuValue] = useState(recalculateMenuValueWithSelectAll(options.map((option) => {
        const value = getValue();
        const isSelected = value.some((singleOption) => singleOption.value === option.value);
        return Object.assign(Object.assign({}, option), { isSelected });
    })));
    const handleSelectAllClick = useCallback(() => {
        let newTemporaryMenuValue;
        const areAllOptionsSelected = temporaryMenuValue.filter((optionWithState) => optionWithState.isSelected).length === options.length;
        if (areAllOptionsSelected) {
            newTemporaryMenuValue = temporaryMenuValue.map((optionWithState) => (Object.assign(Object.assign({}, optionWithState), { isSelected: false, isIndeterminate: optionWithState.isIndeterminate ? false : undefined })));
        }
        else {
            newTemporaryMenuValue = temporaryMenuValue.map((optionWithState) => (Object.assign(Object.assign({}, optionWithState), { isSelected: true, isIndeterminate: optionWithState.isIndeterminate ? false : undefined })));
        }
        setTemporaryMenuValue(newTemporaryMenuValue);
    }, [options, temporaryMenuValue]);
    const handleSingleOptionClick = useCallback((childValue) => {
        let newTemporaryMenuValue = temporaryMenuValue.map((optionWithState) => optionWithState.value === childValue
            ? Object.assign(Object.assign({}, optionWithState), { isSelected: !optionWithState.isSelected }) : optionWithState);
        if (showSelectAll) {
            newTemporaryMenuValue = recalculateMenuValueWithSelectAll(newTemporaryMenuValue);
        }
        setTemporaryMenuValue(newTemporaryMenuValue);
    }, [recalculateMenuValueWithSelectAll, showSelectAll, temporaryMenuValue]);
    const getChildProps = (child) => {
        const childValue = child.props.data.value;
        const currentOptionWithState = temporaryMenuValue.find((singleOption) => singleOption.value === childValue);
        const handleChildClick = () => {
            if (childValue === SELECT_DROPDOWN_SELECT_ALL_VALUE) {
                handleSelectAllClick();
            }
            else {
                handleSingleOptionClick(childValue);
            }
        };
        return {
            customProps: Object.assign(Object.assign({}, child.props.customProps), { isIndeterminate: Boolean(currentOptionWithState === null || currentOptionWithState === void 0 ? void 0 : currentOptionWithState.isIndeterminate) }),
            innerProps: Object.assign(Object.assign({}, child.props.innerProps), { onClick: handleChildClick }),
            isSelected: Boolean(currentOptionWithState === null || currentOptionWithState === void 0 ? void 0 : currentOptionWithState.isSelected),
        };
    };
    const handleSaveClick = useCallback(() => {
        const allSelectedOptions = temporaryMenuValue.filter((optionWithState) => !!optionWithState.isSelected);
        const allSelectedOptionsWithoutSelectAll = allSelectedOptions.filter((optionWithState) => optionWithState.value !== SELECT_DROPDOWN_SELECT_ALL_VALUE);
        const mappedToDefaultOptionType = allSelectedOptionsWithoutSelectAll.map((optionWithState) => ({
            value: optionWithState.value,
            label: optionWithState.label,
        }));
        onSave(mappedToDefaultOptionType);
    }, [onSave, temporaryMenuValue]);
    const handleCancelClick = useCallback(() => {
        onCancel();
    }, [onCancel]);
    if (!children || !Array.isArray(children)) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(components.MenuList, Object.assign({}, props), children.map((child) => {
            if (React.isValidElement(child)) {
                // @ts-ignore
                return React.cloneElement(child, getChildProps(child));
            }
            return React.createElement(React.Fragment, null);
        })),
        React.createElement("div", { className: classes.actions },
            React.createElement(Button, { className: classes.actionButton, id: ix(id, 'cancel-button'), variant: "outlined", color: "primary", onClick: handleCancelClick }, "Cancel"),
            React.createElement(Button, { className: classes.actionButton, id: ix(id, 'save-button'), variant: "contained", color: "primary", onClick: handleSaveClick }, "Save"))));
}
//# sourceMappingURL=AsyncMenuList.js.map